import { algoliasearch } from "algoliasearch";
import { history } from "instantsearch.js/es/lib/routers";
import { useMemo } from "react";
import { HelmetProvider } from "react-helmet-async";
import { InstantSearch } from "react-instantsearch";
import { RouterProvider } from "react-router-dom";
import { routes } from "./routes";

import { configuration } from "./configuration/configuration";

const App = () => {
    const searchClient = useMemo(() => algoliasearch(configuration.algolia.appId, configuration.algolia.apiKey), []);
    const router = {
        router: history({
            cleanUrlOnDispose: true,
        }),
    };

    return (
        <HelmetProvider>
            <InstantSearch
                searchClient={searchClient}
                indexName={configuration.algolia.index}
                routing={router}
                future={{
                    preserveSharedStateOnUnmount: true,
                }}
            >
                <RouterProvider router={routes} />
            </InstantSearch>
        </HelmetProvider>
    );
};

export default App;
